import React, {Component} from 'react';
import { RTLTable,RTLCol,RTLButton } from '../RTLKit';
import {Divider, Icon, Row, Tooltip, Col,Pagination} from 'antd';
import {Field, reduxForm} from "redux-form";

import Loading from '../loading/loading';

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        width:'5%'
    },
    {
        title: 'کد سیستمی',
        dataIndex: 'system_code',
        width:'20%'
    },
    {
        title: 'عنوان',
        dataIndex: 'title',
        width:'20%'
    },
    {
        title: 'کد',
        dataIndex: 'code',
    },
    {
        title: 'عملیات',
        dataIndex: 'action',
        width:'10%'
    }
  ];


class List extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:true,
            pageSize:10,
            current: (this.props.list ? this.props.list.pageNumber : 1)
        }
    }

    componentWillMount() {
        this.props.getList();
    }

    /*--- pagination ---*/
    handlePageChange(pageNumber) {
        this.setState({current: pageNumber});
        this.props.getList({page:pageNumber});
    }

    /*--- fix user list for show in table ---*/
    __fixListForShowInTable() {
        var list = this.props.list;
        var dataSource = [];

        if(list && list.lists) {
            for (let i = 0; i < list.lists.length; i++) {
                dataSource.push({
                    key: (this.state.pageSize*(list.page_number-1))+(i+1),
                    system_code: list.lists[i].system_code,
                    title: list.lists[i].title,
                    code: list.lists[i].code,
                    action: <span>
                                <Tooltip placement="top" title="ویرایش">
                                    <a href={"#/state/edit/"+list.lists[i]._id} className="listBtn"><Icon type="edit" /></a>
                                </Tooltip>
                                <Divider type="vertical" />
                                 <Tooltip placement="top" title="گزارش انبار">
                                    <a href={"#/warehouse/state/"+list.lists[i]._id} className="greenListBtn2"><Icon type="bars" /></a>
                                </Tooltip>
                        </span>

            });
            }
        }
        return dataSource;
    }


    __onChangeCounter(value) {
        this.setState({
            pageSize:value
        })
    }

    __goBack(){
        this.props.history.goBack()
    }

    render() {
        var _self = this;
        const { pageSize } = this.state;
        const { list } = this.props;

        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={21}>
                        <Divider orientation="left">لیست استان ها</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={3} >
                        <RTLButton className="userListBtn" shape="round" type="primary" icon="plus" href="#/state/add">
                            ایجاد استان
                        </RTLButton>
                    </RTLCol>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } pagination={false} columns={columns} dataSource={this.__fixListForShowInTable()} size="small" />
                    <Loading list={list} />
                </Row>
                <Row type="flex" justify="space-between">
                    <RTLCol md={14} className="right">
                        <Pagination
                            name="pageNum"
                            current={this.state.current}
                            total={(list ? list.count : 10)}
                            onChange={(pageNum) => this.handlePageChange(pageNum)}
                            pageSizeOptions = {['10','20','50','100']}
                            showSizeChanger
                            onShowSizeChange={this.__onChangeCounter}
                        />
                    </RTLCol>
                    <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                        بازگشت
                    </RTLButton>
                </Row>
            </div>
        );
    }
}

export default List = reduxForm({
    form: 'list'
})(List)
